/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { SetCoursePositionOptions, SetCoursePositionResponses } from '../../models/SetCoursePosition'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Set the user's position in a course activity.
 * @summary Set Position
 * {@link /course/:course_id/set_position}
 */
export function setCoursePosition<ThrowOnError extends boolean = true>(options: Options<SetCoursePositionOptions, ThrowOnError>): Promise<UnwrappedResult<SetCoursePositionResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/course/{course_id}/set_position', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<SetCoursePositionResponses, ThrowOnError>>
}
